<template>
    <section class="mbs-wrap mbs012b" :style="dBHeight">
        <section class="mbs-header">
            <div class="inner">
                <div class="tit-box">
                    <h3>{{$i18nUtil.trans("title.MyInfo.001","내 정보 관리")}}</h3>
                </div>
            </div>
        </section>
        <div class="pw-box photo-box">
            <div class="photo">
                <img id="userPhoto" alt=""/>
            </div>
            <!-- <div class="photo" v-else>
                <img id="defaultPhoto" src="../../../../../assets/img/noimg.png" alt="" />
            </div> -->
            <div class="photo-edit">
                <button type="button" class="btn-txt-primary" v-show="existPhoto === true" @click="delPhoto">{{$i18nUtil.trans("button.delete","삭제")}}</button>
                <input type="file" style="display: none;" ref="imgInput" @change="imgSelected" enctype="multipart/form-data">
                <button type="button" class="btn-txt-primary black" @click="getPhoto">{{$i18nUtil.trans("button.search","찾아보기")}}</button>
                <div class="info">{{$i18nUtil.trans("message.ModifyInfo.001","권장 사이즈")}} <br>112x112px</div>
            </div>
            <div class="info" v-if="userInfo !== null"
                 v-html="$i18nUtil.trans('message.ModifyInfo.003','* 계정 사용 가능한 기간이 {remainDay}일 남았습니다.',{remainDay:userInfo.remainDay})">
                <div class="droplayer icon info tip relative">
                    <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on">설명</v-btn>
                        </template>
                        <div class="dropdown-list ">
                            <div class="tooltip-b tl" style="width: 373px;">
                                <p>{{$i18nUtil.trans("message.ModifyInfo.004","사용권한 연장이 필요한 경우 초대한 담당자에게 계정사용 연장을 요청해주세요.")}}</p>
                                <ul class="ref">
                                    <li>{{$i18nUtil.trans("message.ModifyInfo.005","* 연장되지 않은 계정은 사용만료일 이후 서비스 접근이 차단됩니다.")}}</li>
                                    <li>{{$i18nUtil.trans("message.ModifyInfo.006","* 계정연장은 전자결재에서 담당자가 신청 가능합니다.")}}</li>
                                </ul>
                            </div>
                        </div>
                    </v-menu>
                </div>
            </div>
            <ul class="list-table" v-if="userInfo !== null">
                <li>
                    <dl>
                        <dt>{{$i18nUtil.trans("entity.user.name","이름")}}</dt>
                        <dd>
                            <form action="">
                                <div class="input-box">
                                    <input type="text" required v-model="userName">
                                    <!-- <button type="reset" class="input-txt-del">입력 삭제</button> -->
                                    <!-- <div class="error" v-if="error">에러 내용입력</div> -->
                                </div>
                            </form>
                            <!-- <button type="button" class="btn-primary-small black">수정</button> -->
                        </dd>
                    </dl>
                </li>
                <li>
                    <dl>
                        <dt>{{$i18nUtil.trans("entity.user.email","이메일")}}</dt>
                        <dd>{{userInfo.email}}</dd>
                    </dl>
                </li>
                <li>
                    <dl>
                        <dt>{{$i18nUtil.trans("entity.user.partnerName","소속회사")}}</dt>
                        <dd>{{userInfo.partnerName}}</dd>
                    </dl>
                </li>
                <li>
                    <dl>
                        <dt>{{$i18nUtil.trans("entity.user.cellPhoneNo","휴대폰번호")}}</dt>
                        <dd>
                            <div>
                                <div class="input-box">
                                    <input type="tel" required v-model="cellPhoneNo">
                                </div>
                                <button type="button" class="btn-primary-small" v-if="isFirst === true" @click="requestOtp">{{$i18nUtil.trans("button.ModifyInfo.001","인증번호 전송")}}</button>
                                <button type="button" class="btn-primary-small black" v-if="isFirst === false" @click="requestOtp">{{$i18nUtil.trans("button.ModifyInfo.002","인증번호 재전송")}}</button>
                            </div>
                            <div>
                                <div class="input-box">
                                    <input
                                        type="number"
                                        id="otp"
                                        name="otp"
                                        v-model="otp"
                                        v-validate="'required'"
                                        placeholder="인증번호"
                                        maxlength="6"
                                        oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                                    />
                                    <span class="time" v-if="countDown !== null">
                                        <span>{{ countDown }}</span>
                                    </span>
                                    <div class="error" v-if="errors.has('otp')">{{$i18nUtil.trans("message.ModifyInfo.007","인증번호를 입력해주세요.")}}</div>
                                </div>
                                <button type="button" class="btn-primary-small black" @click="confirmOtp">{{$i18nUtil.trans("button.confirm","확인")}}</button>
                            </div>
                        </dd>
                    </dl>
                </li>
                <li>
                    <dl>
                        <dt>{{$i18nUtil.trans("message.ModifyInfo.002","비밀번호 변경")}}</dt>
                        <dd>{{$i18nUtil.trans("message.ModifyInfo.008","우측 버튼을 통해 비밀번호를 변경하세요.")}}<button type="button" class="btn-primary-small" @click="modifyPasswordPop">{{$i18nUtil.trans("button.ModifyInfo.003","비밀번호 변경")}}</button></dd>
                    </dl>
                </li>
            </ul>
        </div>
        <div class="btn-box txtc">
            <button type="button" class="btn-primary-medium" @click="cancleUpdateUserInfo">{{$i18nUtil.trans("button.cancel","취소")}}</button>
            <button type="button" class="btn-primary-medium black" @click="updateUserInfo">{{$i18nUtil.trans("button.save","저장")}}</button>
        </div>
        <modals-container @dialogConfirm="dialogConfirm" @dialogSubConfirm="dialogSubConfirm"/>
    </section>
</template>

<script>
import axios from "axios";
import { mapState, mapActions } from "vuex";
import ModifyPassword from "../modal/ModifyPassword";
import Dialog from "@/components/cowork/common/alertMessage/Dialog";
export default {
    props : ['userInfo'],
    data() {
        return {
            isFirst : true,
            isUpdate : false,
            selectedImg : null,
            existPhoto : false,
            /* 타이머 설정 값 */
            minutes: 0,
            secondes: 0,
            time: 300,
            timer: null,
            /* OTP 인증 설정 값 */
            otp : "",
            otpId : "",
            resOtp: "",
            userId : "",
            photoPath : "",
            userName : this.userInfo.userName,
            cellPhoneNo : this.userInfo.cellPhoneNo,
            toastInfo: {
                obj: this.$toasted,
                message: "",
                options: {
                    theme: "toasted-primary",
                    position: "bottom-left",
                    duration: 5000,
                    action : {
                        text : 'x',
                        onClick : (e, toastObject) => {
                            toastObject.goAway(0);
                        }
                    }
                },
            },
            dBHeight: {
                'min-height': (window.innerHeight - 153) + 'px',
            },

        }
    },
    mounted() {
        this.getUserPhoto(this);
    },
    computed: {
        /* OTP 인증 시간 */
        countDown() {
            let time = this.time / 60;
            let minutes = parseInt(time);
            let secondes = Math.round((time - minutes) * 60);

            let min = minutes;
            let sec = secondes;
            if (min < 10) {
                min = "0" + min;
            }
            if (sec < 10) {
                sec = "0" + sec;
            }
            return min + " : " + sec;
        }
    },
    methods : {
        ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
        ...mapActions("modals", ["showDialog", "showToast", "showModal"]),
        getUserPhoto(obj) {
            let img = document.getElementById("userPhoto");
            img.style.width = "114px";
            img.style.height = "114px";
            let imageURI = "/api/auth/org/getLoggedUserPhoto";
            let xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function() {
                if (xhr.readyState == XMLHttpRequest.DONE && xhr.status == 200) {
                    if(xhr.response.size !== 0) {
                        //img.src = URL.createObjectURL(xhr.response);
                        img.setAttribute("src", URL.createObjectURL(xhr.response));
                        img.setAttribute("completed", true);
                        img.classList.remove("hidden");
                        obj.existPhoto = true;
                    } else {
                        img.setAttribute("src", "../../../../../assets/img/noimg.png");
                    }
                }
            };
            xhr.open("POST", imageURI, true);
            var token = localStorage.getItem("Authorization");
            xhr.setRequestHeader("Authorization", token);
            xhr.responseType = "blob";
            xhr.send();
        },
        imgSelected(event) {
            let url = null;
            let img = document.getElementById("userPhoto");

            event.preventDefault();
            this.selectedImg = event.target.files[0];
            url = URL.createObjectURL(this.selectedImg);
            img.src = url;
            this.existPhoto = true;
        },
        getPhoto() {
            this.$refs.imgInput.click();
        },
        delPhoto() {
            //AG061
            let info = {
                title: this.$i18nUtil.trans("title.dialog.notice","알림"),
                button: this.$i18nUtil.trans("button.dialog.confirm","확인"),
                kbn : "DELPHOTO",
                subButton : this.$i18nUtil.trans("button.dialog.cancel","취소"),
                contents: this.$i18nUtil.trans("AG061")
            };
            this.handleDialog(info);
        },
        /* 인증번호 생성 */
        requestOtp() {
            this.isFirst = false;
            let obj = this;
            let reqData = {
                url: "/api/auth/org/requestOtp",
                method: "post",
                params: {
                    otpKbn : "MODINFO",
                    otpId: obj.otpId,
                    cellPhoneNo : obj.cellPhoneNo
                }
            };
            obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then(function(res) {
                let info = {
                    title: this.$i18nUtil.trans("title.dialog.notice","알림"),
                    button: this.$i18nUtil.trans("button.dialog.confirm","확인")
                };
                if(res.errorCode !== null) {
                    let errorCode = res.errorCode;
                    if(errorCode === "AG026") {
                        info.contents = obj.$i18nUtil.trans("AG026");
                    }
                    obj.handleDialog(info);
                } else {
                    if (res.result.otpId != null) {
                        console.log("OTP 번호 :: " + res.result.otp);
//                        obj.resOtp = res.result.otp;
                        obj.otpId = res.result.otpId;
                        obj.time = 300;
                        obj.handleCountDown();
                        info.contents = obj.$i18nUtil.trans("AG014");
                        obj.handleDialog(info);
                    }
                }
            })
            .catch(function(err) {
                console.log(err);
            });
        },
        confirmOtp() {
            if (this.time === 0) {
                let info = {
                    title: this.$i18nUtil.trans("title.dialog.notice","알림"),
                    contents: this.$i18nUtil.trans("AG015"),
                    button: this.$i18nUtil.trans("button.dialog.confirm","확인")
                };
                this.handleDialog(info);
            } else {
                if (this.otp !== null) {
                    let obj = this;
                    let reqData = {
                        url: "/api/auth/org/confirmOtp",
                        method: "post",
                        params: {
                            otp: obj.otp,
                            otpId: obj.otpId,
                            userId: obj.userId,
                        }
                    };
                    obj
                    .COWORK_REST_SIMPLE_ACTION(reqData)
                    .then(function(res) {
                        let info = {
                            title: this.$i18nUtil.trans("title.dialog.notice","알림"),
                            button: this.$i18nUtil.trans("button.dialog.confirm","확인")
                        };
                        if(res.errorCode !== null) {
                            let errorCode = res.errorCode;
                            if (errorCode === "AG017") {
                                info.contents = obj.$i18nUtil.trans("AG017");
                            } else if(errorCode === "UB044") {
                                info.contents = obj.$i18nUtil.trans("UB044");
                            }
                            obj.handleDialog(info);
                        } else {
                            if(res.result !== null) {
                                if(res.result === true) {
                                    info.contents = "인증 되었습니다.",
                                    obj.handleDialog(info);
                                    clearInterval(obj.timer);
                                    obj.time = 0;
                                }
                            }
                        }
                    })
                    .catch(function(err){
                        console.log(err);
                    })
                } else {
                    let info = {
                        title: this.$i18nUtil.trans("title.dialog.notice","알림"),
                        contents: this.$i18nUtil.trans("UB044"),
                        button: this.$i18nUtil.trans("button.dialog.confirm","확인")
                    };
                    this.handleDialog(info);
                }
            }
        },
        updateUserInfo() {
            let obj = this;
            let formData = new FormData();
            let header = {
                "Content-Type": "multipart/form-data",
                Authorization: localStorage.getItem("Authorization"),
            };
            formData.append("userPhoto", obj.selectedImg);
            formData.append("userName", String(obj.userName));
            formData.append("cellPhoneNo", String(obj.cellPhoneNo));
            obj.$axios
            .post("/api/auth/org/modifyUserInfo", formData, header)
            .then((res) => {
                if(res.data.errorCode !== null) {
                    let info = {
                        title: this.$i18nUtil.trans("title.dialog.notice","알림"),
                        contents: "정보가 수정이 실패하였습니다.",
                        button: this.$i18nUtil.trans("button.dialog.confirm","확인")
                    };
                    obj.handleDialog(info);
                } else {
                    /* TODO. 개인정보 수정 저장 후, 메시지 처리 필요 없는지 확인 필요(화면설계서에는 메시지 정의 없음) */
                    // obj.toastInfo.message = obj.$i18nUtil.trans("TB054");
                    // obj.showToast(obj.toastInfo);
                    obj.$emit('changeStatus', {isModify : false});
                }
            })
            .catch((err) => {
                console.log(err);
            })
        },
        /* 비밀번호 재설정 */
        modifyPasswordPop() {
            const modalInfo = {
                width: "500px",
                height: "519px",
                obj: this.$modal,
                component: ModifyPassword
            };
            this.showModal(modalInfo);
        },
        /* 개인정보 수정 취소 */
        cancleUpdateUserInfo() {
            let info = {
                title: this.$i18nUtil.trans("title.dialog.notice","알림"),
                button: this.$i18nUtil.trans("button.dialog.confirm","확인"),
                subButton : this.$i18nUtil.trans("button.dialog.cancel","취소"),
                contents: this.$i18nUtil.trans("AG060")
            };
            this.handleDialog(info);
        },
        /* 알림 Dialog */
        handleDialog(info) {
            const dialogInfo = {
                kbn : info.kbn,
                obj: this.$modal,
                component: Dialog,
                title : info.title,
                button : info.button,
                subButton : info.subButton,
                contents : info.contents
            };
            this.showDialog(dialogInfo);
        },
        /* 개인정보 수정 취소 > 확인 */
        dialogConfirm(param) {
            if(param.subButton !== undefined) {
                if(param.kbn === "DELPHOTO") {
                    let img = document.getElementById("userPhoto");
                    img.src = null;
                    this.selectedImg = null;
                    this.existPhoto = false;
                } else {
                    this.$emit('changeStatus', {isModify : false});
                }
            }
        },
        /* 개인정보 수정 취소 > 취소 */
        dialogSubConfirm(param) {
        },
        /* OTP 인증 만료 시간 */
        handleCountDown(timer) {
            if (timer !== null) {
                clearInterval(this.timer);
                this.timer = setInterval(() => {
                    if (this.time > 0) {
                        this.time--;
                    } else {
                        clearInterval(this.timer);
                    }
                }, 1000);
            } else {
                this.timer = setInterval(() => {
                    if (this.time > 0) {
                        this.time--;
                    } else {
                        clearInterval(this.timer);
                    }
                }, 1000);
            }
        },
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/cowork/common/myInfo/external/ModifyInfo.vue